export const IncidentTypeMap = {
    CROWD_STATISTIC: 'INCIDENT_CROWD',
    QUEUE: 'INCIDENT_QUEUE_COUNTING',
    OFF_DUTY_DETECTION: 'INCIDENT_OFF_DUTY',
    CROWD_INTRUSION: 'CROWD_INTRUSION_RESULT_HEAD',
    CROWD_STRAND: 'CROWD_STRAND',
    CROWD_SOCIAL_DISTANCE: 'CROWD_SOCIAL_DISTANCE',
    CROWD_CONGREGATE: 'CROWD_CONGREGATE',
    CROWD_RETROGRADE: 'CROWD_RETROGRADE',
    ROAD_DEFECTION_DETECT: 'ROAD_DEFECTION_DETECT',
    KITCHEN_STAFF_DETECT: 'KITCHEN_STAFF_DETECT',
    CROWD_CROSS_LINE_STATISTIC: 'CROWD_CROSS_LINE_STATISTIC',
    CROSS_LINE_ALERT_DETECT: 'CROSS_LINE_ALERT_DETECT',
    TRASH_DETECT: 'TRASH_DETECT',
    FIRE_DETECTION_DETECT: 'FIRE_DETECTION_DETECT',
    ABNORMAL_BEHAVIOR_DETECT: 'ABNORMAL_BEHAVIOR_DETECT',
    TRAFFIC_RETROGRADE_DETECT: 'TRAFFIC_RETROGRADE_DETECT',
    TRAFFIC_VIOLATION_DETECT: 'TRAFFIC_VIOLATION_DETECT',
    VIRTUAL_ZONE_STATISTIC: 'VIRTUAL_ZONE_STATISTIC',
    NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECT: 'NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECT',
    TRAFFIC_CONGESTION_DETECT: 'TRAFFIC_CONGESTION_DETECT',
    PEDESTRIAN_CROSS_LINE: 'PEDESTRIAN_CROSS_LINE',
    FACE_ATTRIBUTE: 'FACE_ATTRIBUTE',
    FACE_PEDESTRIAN_ALERT: 'FACE_PEDESTRIAN_ALERT',
    FACE_ALERT: 'FACE_ALERT',
    INCIDENT_EVERYTHING_MATCHED: 'INCIDENT_EVERYTHING_MATCHED',
    INCIDENT_EVERYTHING_UNMATCHED: 'INCIDENT_EVERYTHING_UNMATCHED', // 人脸未比中
};
export const DEVICE_MAX_NUM = 4; // 最大可选设备数
export const NODE_TYPE_DEVICE_GROUP = 'DEVICE_GROUP'; // 设备组
export const WARN_MESSAGE = 'warnMessage';
export const FaceType = [
    'FACE_MATCH',
    'FACE_PEDESTRIAN',
    'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED',
    'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED',
    'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED',
];
export const SNAP_COLLAPSE_NUM = 30;
export const SNAP_OPEN_NUM = 100;
export const RecordTimeOptions = [
    {
        value: 10,
        label: '10 Min',
    },
    {
        value: 30,
        label: '30 Min',
    },
    {
        value: 60,
        label: '60 Min',
    },
    {
        value: 1440,
        label: '24 Hour',
    },
];
export const RecordDefaultTime = ['00:00:00', '23:59:59'];
